// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import {
    FC,
    ComponentProps,
} from 'react';
import {
    FormField,
    FormFieldProps,
} from '@plesk/ui-library';
import TagsInput from 'common/components/Form/FormFieldTags/TagsInput';

export interface IFormFieldTagsProps extends FormFieldProps {
    placeholder?: string;
    disabled?: boolean;
    autoFocus?: boolean;
    delimiters?: string[];
    inputProps?: Partial<ComponentProps<typeof TagsInput>>;
}

const FormFieldTags: FC<IFormFieldTagsProps> = ({ placeholder, disabled, autoFocus, delimiters, inputProps, ...props }) => (
    <FormField {...props}>
        {({ getValue, setValue, getId, getName }) => (
            <TagsInput
                inputId={getId()}
                name={getName()}
                value={getValue()}
                onChange={setValue}
                placeholder={placeholder}
                disabled={disabled}
                autoFocus={autoFocus}
                delimiters={delimiters}
                {...inputProps}
            />
        )}
    </FormField>
);

export default FormFieldTags;
